import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";

import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { IAutoComplete } from "../../interfaces/IAutoComplete";

const getAutoCompleteBinusian = async (search: string) => {
  const objData: IAutoComplete[] = [];

  const data = HttpService.post(
    ApiService.apiHc.getAutoCompleteBinusian,
    JSON.stringify({
      AutoCompleteSearch: search,
    })
  );
  const dataAPI = (await data).data;
  const jsonParse = JSON.parse(dataAPI.data);
  jsonParse.data.forEach((datas: any) => {
    objData.push({
      binusianIDEmail: `${datas.email_Edu}~${datas.binusianID}`,
      name: `${datas.email_Edu} - ${datas.name}`,
    });
  });

  return objData;
};

export default function AutocompleteDisabledComponent({ propsData, name }) {
  const { handleChange, handleBlur, values } = propsData;
  const [open, setOpen] = useState(false);
  const [changeText, setChangetText] = useState("");
  const [options, setOptions] = useState<readonly IAutoComplete[]>([]);

  const sendDataToParent = (event) => {
    handleChange(event);
  };
  const handleOnBlur = (event) => {
    handleBlur(event);
  };

  const handleClickChange = (event, newValue) => {
    if (newValue != null) {
      values[name] = {
        binusianIDEmail: newValue.binusianIDEmail,
        name: newValue.name,
      };
    } else {
      values[name] = null;
    }
  };

  const handleTextChange = (event, newValue) => {
    setChangetText(newValue);
  };

  // useEffect(() => {
  //     (async () => {
  //         if (changeText.length > 2) {
  //             const dataStaff = await getAutoCompleteBinusian(changeText);
  //             setOptions(dataStaff)
  //         } else {
  //             setOptions([])
  //         }
  //     })();
  // }, [changeText]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      sx={{ width: "100%" }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        setChangetText("");
      }}
      inputValue={changeText}
      isOptionEqualToValue={(option, value) =>
        option.binusianIDEmail === value.binusianIDEmail
      }
      getOptionLabel={(option) => option.name}
      options={options}
      noOptionsText="Please Type 3 Text"
      onChange={handleClickChange}
      onInputChange={handleTextChange}
      value={values[name]}
      disabled
      renderInput={(params) => (
        <TextField
          onChange={sendDataToParent}
          onBlur={handleOnBlur}
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {open && changeText.length > 0 ? (
                  <CircularProgress color="inherit" size={15} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
